import { Pipe, PipeTransform } from '@angular/core';
import { startCase } from 'lodash';

@Pipe({
  name: 'sentence'
})
export class SentencePipe implements PipeTransform {

  transform(value: string): string {
    return startCase(value);
  }

}
